/* eslint-disable react/jsx-props-no-spreading */
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Divider } from '@mui/material';
import React from 'react';

import SectionItem, { SectionItemProps } from './SectionItem';

function SectionItemSortable(props: SectionItemProps) {
  const {
    section,
  } = props;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: section.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div key={section.id} style={style} ref={setNodeRef} {...attributes}>
      <SectionItem {...props} listeners={listeners} />
      <Divider />
    </div>
  );
}

export default SectionItemSortable;
